import {Component, Input} from '@angular/core';

export interface PropertyDocument {
    name: string;
    status: 'VALID' | 'MISSING';
    icon: string; // ruta al ícono o nombre de material icon
}

@Component({
  selector: 'app-property-documents',
  templateUrl: './property-documents.component.html',
  styleUrls: ['./property-documents.component.scss']
})
export class PropertyDocumentsComponent {
    @Input() documents: PropertyDocument[] = [];

}
